import { createSlice } from '@reduxjs/toolkit';
const CHECKBOX_INITIAL_STATE={
  cbSelectedAllRecords:false,
  cbActiveIds:[],
};
const GlobalFilterSlice = createSlice({
  name: 'global_filter',
  initialState: {
    data: {},
    checkbox:CHECKBOX_INITIAL_STATE,
    showScheduledVisits: false, // Toggle state for filtering scheduled visits (today and future)
  },
  reducers: {
    updateGlobalFilter: (state, action) => {
      state.data = action.payload;
    },
    resetGlobalFilter: (state) => {
      state.data = {}; 
    },
    //checkbox reducers
    setSelectedAllRecords: (state, action) => {
      state.checkbox.cbSelectedAllRecords = action.payload;
    },
    setActiveIds: (state, action) => {
      state.checkbox.cbActiveIds = action.payload;
    },
    clearCbState: (state, action = false) => {
      state.checkbox = CHECKBOX_INITIAL_STATE;

    },
    // Scheduled visits toggle reducer
    setShowScheduledVisits: (state, action) => {
      state.showScheduledVisits = action.payload;
    },
  },
  extraReducers: (builder) => {
  },
});

export const { updateGlobalFilter,resetGlobalFilter,setSelectedAllRecords,setActiveIds,clearCbState,setShowScheduledVisits} = GlobalFilterSlice.actions;

export const getGlobalFilterState = (state) => state.globalFilter.data;
export const checkBoxActiveIds = (state) => state.globalFilter.checkbox.cbActiveIds;
export const checkBoxSelectedAllRecords = (state) => state.globalFilter.checkbox.cbSelectedAllRecords;
export const getShowScheduledVisits = (state) => state.globalFilter.showScheduledVisits;
export default GlobalFilterSlice.reducer;
